<template>
  <div class="mt-2">
    <v-card>
      <v-toolbar
        dense
        color="white"
        class="elevation-0"
      >
        <v-toolbar-title>
          <v-icon>mdi-truck</v-icon>
          היסטוריית העברת חנויות
        </v-toolbar-title>
      </v-toolbar>
      <v-divider />
      <v-card-text>
        <v-progress-linear
          indeterminate
          height="2"
          v-if="fetching"
        ></v-progress-linear>
        <template v-else-if="storeTransfers.length">
          <v-data-table
            :headers="headers"
            :items="storeTransfers"
            must-sort
            :options.sync="options"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td class="text-start">{{ heDate(item.created) }} {{ format(item.created, 'HH:mm') }}</td>
                <td>{{ storeById(item.store) || 'ללא חנות' }}</td>
                <td class="text-start">{{ boxTypeById(item.boxType) || 'ללא מגירה' }}</td>
                <td class="text-start">{{ userById(item.user) }}</td>
              </tr>
            </template>
          </v-data-table>
        </template>
        <v-alert
          :value="true"
          color="white"
          class="ma-0 grey--text"
          v-else
        >
          לא היו העברות חנויות
        </v-alert>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { format, isAfter } from "date-fns";
// import shouldShow from "@/utils/shouldShow";

export default {
  data() {
    return {
      fetching: false,
      headers: [
        { text: "תאריך", align: "right", value: "created" },
        { text: "חנות", align: "right", value: "store" },
        { text: "מגירה", align: "right", value: "boxType" },
        { text: "מבצע", align: "right", value: "user" }
      ],
      options: {
        sortDesc: [true],
        sortBy: ["created"]
      }
    };
  },
  methods: {
    format,
    heDate(d) {
      let date = new Date(d);
      let options = { weekday: "long", month: "long", day: "numeric" };
      return new Intl.DateTimeFormat("he-IL", options).format(date);
    },
    fetch() {
      this.fetching = true;
      let query = {
        device: this.device._id
      };
      this.$store
        .dispatch("API_GET", {
          url: "/store-transfers",
          entityType: "storeTransfers",
          schema: "storeTransferListSchema",
          params: { q: JSON.stringify(query), limit: 0 }
        })
        .catch(err => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    storeById(id) {
      if (id) {
        let store = this.$store.state.entities.stores[id];
        if (store) {
          return store.title;
        }
      }
    },
    boxTypeById(id) {
      if (id) {
        let boxType = this.$store.state.entities.boxTypes[id];
        if (boxType) {
          return boxType.title;
        }
      }
    },
    userById(id) {
      if (id) {
        let user = this.$store.state.entities.users[id];
        if (user) {
          return user.name;
        }
      }
    }
  },
  computed: {
    storeTransfers() {
      return Object.values(this.$store.state.entities.storeTransfers)
        .filter(item => {
          return item.device && item.device === this.device._id;
        })
        .sort((a, b) => {
          return isAfter(a.created, b.created) ? -1 : 1;
        });
    }
  },
  props: ["device"],
  watch: {},
  mounted() {
    this.fetch();
  },
  components: {},
  mixins: []
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>